import * as React from 'react';
import FormInput from "../../atom/form/form_input";
import ErrorText from "../../atom/text/error_text";
import Label from "../../atom/label/label";
import styled from "styled-components";
import {ConstColor} from "../../../../config/styles_const/styles_const";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
    type: string;
    placeholder: string;
    name: string;
    label: string;
    hasError: boolean;
    errorText: string;
    input?: any;
    require?: boolean;
    unit?: string;
}

const FormGroupInput: React.FC<IProps> = (props) => {

    const {type, placeholder, name, label, hasError, errorText, input, require, unit} = props;

    return (
        <Wrapper>
            {label && <Label  require={require} htmlFor={name} marginBottom={true}>{label}</Label>}
            <FormInputWrapper>
                <CustomInput
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    hasError={hasError}
                />
                {unit && <UnitWrapper><ParagraphSup bold={true}>{unit}</ParagraphSup></UnitWrapper>}
            </FormInputWrapper>
            {hasError &&
            <ErrorText>{errorText}</ErrorText>
            }
        </Wrapper>
    );
};

export default (FormGroupInput);

const CustomInput = styled(FormInput)`
    // chrome のautofill時のcss打ち消し用　背景色が違う場合の対応しやすくするためFormInputではなくここに記述
    input&:-webkit-autofill,
    input&:-webkit-autofill:hover, 
    input&:-webkit-autofill:focus{
        -webkit-text-fill-color: ${ConstColor.Base};
        -webkit-box-shadow: 0 0 0px 1000px ${ConstColor.White} inset;
        transition: background-color 5000s ease-in-out 0s;
    }
`;

const Wrapper = styled.div`
    width: 100%;    
`

const FormInputWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    
`

const UnitWrapper = styled.div`
    margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_input.tsx